import React from 'react';

// "definitionofthe ___": the blank is the word the visitor brings
const Wordmark = ({ className = '' }) => (
  <span className={`inline-flex items-baseline gap-1 font-display tracking-[-0.01em] text-ink ${className}`}>
    definitionofthe
    <span aria-hidden="true" className="inline-block h-[0.28em] w-[1.5em] translate-y-[0.06em] rounded-full bg-tangerine" />
  </span>
);

export default Wordmark;
